<template>
  <div id="app">
    <Mapview></Mapview>
  </div>
</template>
<script>
import Mapview from "./components/MapContainer.vue"
export default {
  name: 'App',
  components: {
    Mapview
  }
}
</script>

<style  scoped>
  #app {
    height: 100%;
    width: 100%;
    margin: 0;
  }
</style>
